import { useMutation } from "@tanstack/react-query";
import { useContext, useState } from "react";

//Snackbar
import Snackbar from "../common/VFX-UI/SnackBar/Snackbar";

//App
import UserForm from "./UserForm";
import { UserViewModel } from "../../viewModels/userViewModel";
import { UserFormContainerProps } from "../../types";
import userApi from "../../app/model/api/userApi";
import { UsersContext } from "./UsersContainer";
import { apiErrorMessage } from "../../utility/lib/error";
import { EMPTY_GUID } from "../../utility/constants/constants";
import { UserDto } from "../../app/model/api/types/dto/userDto";
import { useUserLookupQuery } from "./hooks/useUser";

interface SnackbarState {
  showErrorSnackbar: boolean;
  errorMessage: string;
}

export const UserFormContainer = (props: UserFormContainerProps) => {
  const { onClose, onShowSuccess, organizationId } = props;
  const usersContext = useContext(UsersContext);

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = usersContext?.id ? "User updated" : "New User added";

  const onShowErrorSnackbar = (errorMessage: string) => {
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });
  };
  const onCloseSnackbar = () => {
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });
  };

  const userLookupQuery = useUserLookupQuery();

  const { status, mutate } = useMutation<void, Error, UserDto>({
    mutationFn: async (payload: UserDto) => {
      const response = await userApi.save(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
  });

  const handleOnSubmitHandler = async (values: UserViewModel) => {
      const user: UserDto = values.toDto();
    if (user.id == null) user.id = EMPTY_GUID;
    if (user.id === EMPTY_GUID) user.phoneNumberConfirmed = false;
    if (
      organizationId !== EMPTY_GUID &&
      organizationId !== null &&
      organizationId !== undefined
    )
      user.organizationId = organizationId;
    else user.organizationId = null;
    mutate(user);
  };

  const initialValues = usersContext?.id
    ? new UserViewModel(
        usersContext?.id ?? null,
        organizationId ?? null,
        usersContext.data?.firstName ?? null,
        usersContext.data?.lastName ?? null,
        usersContext.data?.roleId !== null &&
        usersContext.data?.roleId !== undefined
          ? [usersContext.data?.roleId]
            : null,
        usersContext.data?.userName ?? null,
        usersContext.data?.email ?? null,
        usersContext.data?.phoneNumber ?? null,
        usersContext.data?.isActive ?? true,
        usersContext.data?.createdDateUtc ?? null
      )
    : new UserViewModel(
        EMPTY_GUID,
        organizationId ?? null,
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        null
      );

  return (
    <>
      <UserForm
        handleOnSubmit={handleOnSubmitHandler}
        onClose={onClose}
        initialVal={initialValues}
        status={status}
        lookups={userLookupQuery?.data?.result}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};
